"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShutterstockTosLinks;

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

function i18nKey(suffix) {
  return "FileManagerCore.shutterstock." + suffix;
}

function getClassName(compact) {
  return compact ? 'm-right-1' : 'm-right-4';
}

function ShutterstockTosLinks(props) {
  var use = props.use,
      compact = props.compact;
  var className = getClassName(compact);
  return _react.default.createElement(_UIList.default, {
    className: "shutterstock-tos-links",
    inline: true
  }, _react.default.createElement(_UILink.default, {
    className: className,
    use: use,
    external: true,
    href: "https://www.shutterstock.com/terms"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: i18nKey('websiteTerms')
  })), _react.default.createElement(_UILink.default, {
    className: className,
    use: use,
    external: true,
    href: "https://www.shutterstock.com/privacy"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: i18nKey('privacyPolicy')
  })), _react.default.createElement(_UILink.default, {
    use: use,
    external: true,
    href: "https://www.shutterstock.com/license"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: i18nKey('licensingTerms')
  })));
}

ShutterstockTosLinks.propTypes = {
  use: _UILink.default.propTypes.use,
  compact: _react.PropTypes.bool
};
ShutterstockTosLinks.defaultProps = {
  use: 'dark',
  compact: false
};
module.exports = exports.default;